import {rdProxy} from '@/api/index';

function encrypt(params){
    return rdProxy.post('encrypt', params);
}
function encryptEmployee(params){
    return rdProxy.post('employee', params);
}
function getPageSignData(params){
    return rdProxy.get('page-sign-data', {params});
}
function saveSign(params){
    return rdProxy.post('page-sign-data', params);
}
function checkSign(params){
    return rdProxy.post('check-sign', params);
}

export {encrypt, encryptEmployee, getPageSignData, saveSign, checkSign};